<div class="emd-container">
    <div class="emd-container__header eu-height_auto">
        <div class="emd-status-bar _color_success"></div>
        <br>
        <br>
        <h2 class="emd-text _size_subpage _color_default">
            {{titleModal}}
        </h2>
        <div [innerHTML]="bodyModal | safeHtml"></div>
    </div>
    <div class="emd-container__content">
        <!-- Botão de fechar a direita do box -->
        <div class="emd-container__aside">
            <button class="emd-btn _color_clear" (click)='closeConfirmModal()'>
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>
    <div class="emd-container__footer">
        <button class="emd-btn _color_success _type_outline _block" (click)='closeConfirmModal()'>Ok</button>
    </div>
</div>